import { Box, Text } from 'grommet';
import { tableHeaderTextProps } from '../../TableHeaderItem';

export interface ITitleRowProps {
  isUnion?: boolean;
}

/** The session estimate table's header; money and number columns are right-aligned, like their values */
export const TitleRow = (_props: ITitleRowProps) => {
  return (
    <Box
      direction="row"
      gap="medium"
      pad={{ vertical: 'small', horizontal: 'medium' }}
      border={{ side: 'bottom', color: 'border-card' }}
      background="surface-header"
    >
      <Box fill="horizontal">
        <Text {...tableHeaderTextProps}>Title</Text>
      </Box>
      <Box width="75%" align="end">
        <Text {...tableHeaderTextProps}>Units</Text>
      </Box>
      <Box width="55%" align="end">
        <Text {...tableHeaderTextProps}>Rate</Text>
      </Box>
      <Box width="60%" align="end">
        <Text {...tableHeaderTextProps}>Wages</Text>
      </Box>
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>P&H</Text>
      </Box>
      {/* <Box width="40%">{isUnion && <Text size="small">P & H</Text>}</Box> */}
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>Handling</Text>
      </Box>
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>Taxes</Text>
      </Box>
      <Box width="70%" align="end">
        <Text {...tableHeaderTextProps}>Total</Text>
      </Box>
      <Box width="40px" flex={false} />
    </Box>
  );
};
